const tableSettingToStore = (key) => ({
  computed: {
    storeKeyPageSize() {
      let prefix = key || "default";
      return `${prefix}_table_pagesize`
    },

    mixinPageSize() {
      return this.pagination?.pageSize
    }
  },

  watch: {
    mixinPageSize() {
      this.$store.commit('Set_Individualization_Setting', { key: this.storeKeyPageSize, value: this.mixinPageSize })
    }
  },

  created() {
    let pageSize = this.$store.getters.individualizationSettings(this.storeKeyPageSize);
    if (pageSize && this.pagination) {
      this.pagination.pageSize = pageSize
    }
  }
})

export {
  tableSettingToStore
}

export default tableSettingToStore